//AzeemKhan : 17-01-2023 : BT-97769 -  Breeze - Account Registration (eKYC) - Start
import { getAppSyncDetailsByTenant, getAppSyncDetailsByUser, termsCondtion, aboutUs, disclaimer, exchangeTimings, brokerInformation, statesCities, connectSocket, createUserPreference, setRegDetails } from "../../apis";//Prachi T - 07-12-2023 - BT-109052 - Breeze- Font and Colour Settings
import { getAppInfoData, getDecryptLocalStorage, isGuestUser, setEncryptLocalStorage, setInitialConfigs } from "../../utils/global_functions";
import { APP_INFO } from "../actionTypes";
import { updateActiveWatchlist, updateColumnWiseColumns, updateGlobalWatchlist, updateIsWatchlistPresent, updateOpenWatchlist, updateTenantColumnPorfiles, updateWatchListAction, updateWatchlistandDefault } from "./watchlist";
import config from '../../config.json';
import { updateTenantUserPreference, userPreferenceSuccess } from "./header";
import { _getDynamicMenus } from "../../controllers/appInfo";
import { APP_INFO_PARAMS, LOCAL_STORAGE_KEYS } from "../../utils/global_variables";
import { getViewWiseColumnsList, sipTermsCondition} from "../../apis/cdn_service";
import { checkAddendumNotice } from "./addEndumAndNotices";
import BzViewWiseColumnList from '../../utils/BzViewWiseColumnList.json';
import { store } from "../store";
import { updateIsLoading } from "./auth";


export const appDetailsByTenant = (app) => async (dispatch) => {
    try {
        const objResp = await getAppSyncDetailsByTenant();
        store.dispatch(updateIsLoading(false));
        //// Ajitesh 23/05/2024 - appsyncdetails api v2 functionality start
        // let propsForResponse = keyIvFromSalt();
        // let appSyncDetailsResponse = disentangle(propsForResponse.key, propsForResponse.iv, objResp?.data?.data);
        // if (appSyncDetailsResponse !== "") {
        //     objResp.data.data = JSON.parse(appSyncDetailsResponse);
        // }
        //// Ajitesh 23/05/2024 - appsyncdetails api v2 functionality end
        dispatch(appInfoSuccess(objResp?.data?.data?.app_info));
        setInitialConfigs(objResp?.data?.data?.app_info);
        //Ameersha N : BT-95888-Create Watchlist -Start
        if (objResp?.data?.data?.column_profile?.length > 0) {
            dispatch(updateTenantColumnPorfiles(objResp?.data?.data?.column_profile));
        } else {
            // dispatch(updateTenantColumnPorfiles([default_Column_profile_by_tenant]));
        }
        //Ameersha N : BT-95888-Create Watchlist -End
        dispatch(updateGlobalWatchlist(objResp?.data?.data?.watchlist));
        //Prachi T - 02-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
        //to get default userPreference
        if (objResp?.data?.data?.user_preference?.length) {
            dispatch(updateTenantUserPreference(objResp?.data?.data?.user_preference[0]));
        }
        //Prachi T - 02-11-2023 - BT-110050 - Breeze- Settings Preferences - End
        return Promise.resolve(objResp);

    } catch (error) {
        console.log(error);
        //Maaz A : 16-11-2023 : Infinite API failing issue fix - Start
        dispatch(appInfoFailure(error));
        //Maaz A : 16-11-2023 : Infinite API failing issue fix - End
        dispatch(updateGlobalWatchlist([]));

    }
};


export const appDetailsByUser = () => async (dispatch, getState) => {
    // This will call only on success login session generetaed
    try {
        const objResp = await getAppSyncDetailsByUser();
        // Ameersha N : 12-12-2023 : BT-116461 Breeze - Addendum and Notices --Start
        let appInfo = getState()?.appInfo?.appInfo;
        if (!isGuestUser()) {
            dispatch(checkAddendumNotice(appInfo));
        } else { }
        // Ameersha N : 12-12-2023 : BT-116461 Breeze - Addendum and Notices --End
        //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
        const objColumnResp = await getViewWiseColumnsList();
        if (objColumnResp) {
            dispatch(updateColumnWiseColumns(objColumnResp?.data));
        } else {
            dispatch(updateColumnWiseColumns(BzViewWiseColumnList));
        }
        //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End
        await dispatch(updateWatchlistandDefault(objResp?.data?.data?.watchlist, objResp?.data?.data?.column_profile));
        connectSocket(config.WFH);
        if (objResp?.data?.data?.user_preference?.length > 0) {
            //Prachi T [06-12-2023] : Breeze- Font and Colour Settings - Start
            const sortedUsers = [...objResp?.data?.data?.user_preference].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            if (sortedUsers?.length > 0) {
                dispatch(userPreferenceSuccess([sortedUsers[0]]));
            }
            //Prachi T [06-12-2023] : Breeze- Font and Colour Settings - End
            //Prachi T - 07-12-2023 - BT-109052 - Breeze- Font and Colour Settings - Start
        } else {
            const objUserPreferenceResp = await createUserPreference({
                "sProfilePicPath": "",
                "sOrder": null,
                "sNotification": "",
                "sInAppNotification": null,
                "sTheme": "light",
                "sExchange": null
            });
            if (objUserPreferenceResp?.data?.data) {
                dispatch(userPreferenceSuccess([objUserPreferenceResp?.data?.data]));
                setEncryptLocalStorage(LOCAL_STORAGE_KEYS.THEME, objUserPreferenceResp?.data?.data?.sTheme);
            }
            //Prachi T - 07-12-2023 - BT-109052 - Breeze- Font and Colour Settings - End
        }
        //dispatchi updateIsWatchlistPresent to update a redux state in watchlist as true so only when that state is true and watchlist lenngth is zero without holdings and dontmiss watchlist then only dependent function will work correctly
        dispatch(updateIsWatchlistPresent(true));
        return Promise.resolve();

    } catch (error) {
        if (error?.response?.data) {
            dispatch(updateWatchListAction(error?.response?.data));
        } else {
            dispatch(updateWatchListAction([]));
        }
        dispatch(updateOpenWatchlist([]));
        dispatch(updateActiveWatchlist({}));
        dispatch(updateIsWatchlistPresent(false));
        if(isGuestUser()){
            const storedWatchlist = JSON.parse(getDecryptLocalStorage('GUEST_WATCHLIST'))
            if(storedWatchlist){
                dispatch(updateWatchlistandDefault(storedWatchlist,[]))
            }else{
                dispatch(updateWatchlistandDefault([],[]))
                dispatch(updateIsWatchlistPresent(false));
            }
        }
        return Promise.reject();
    }
};

export const setRegistrationDetails = (payload) => async (dispatch) => {
    try {
        const objResp = await setRegDetails(payload);
    } catch (error) {

    }

};


export const appInfoSuccess = (payload) => {
    return { type: APP_INFO.GET_APPINFO_SUCCESS, payload };
};

export const appInfoFailure = (payload) => {
    return { type: APP_INFO.GET_APPINFO_FAILURE, payload };
};

//AzeemKhan : 17-01-2023 : BT-97769 -  Breeze - Account Registration (eKYC) - End




export const getTermsAndCondition = (source) => async (dispatch) => {
    try {
        let objResp
        if(source === 'sip'){
            objResp = await sipTermsCondition(source);
        }else{
            objResp = await termsCondtion(source);
        }
        const data = await objResp?.data;
        dispatch(termsAndConditionSuccess(data));
        return Promise.resolve(data);

    } catch (error) {
        console.log(error);
        dispatch(termsAndConditionFailure([]));
    }

};


export const termsAndConditionSuccess = (objResp) => {
    return { type: APP_INFO.GET_TERMS_AND_CONDITION_SUCCESS, payload: objResp };
};

export const termsAndConditionFailure = (payload) => {
    return { type: APP_INFO.GET_TERMS_AND_CONDITION_FAILURE, payload };
};

export const getAboutUs = () => async (dispatch) => {
    try {
        const objResp = await aboutUs();
        const data = await objResp?.data;
        dispatch(aboutUsSuccess(data));
        return Promise.resolve(data);
    } catch (error) {
        console.log(error);
        dispatch(aboutUsFailure([]));
    }

};
export const aboutUsSuccess = (objResp) => {
    return { type: APP_INFO.GET_ABOUT_US_SUCCESS, payload: objResp };
};

export const aboutUsFailure = (payload) => {
    return { type: APP_INFO.GET_ABOUT_US_FAILURE, payload };
};

export const getDisclaimer = () => async (dispatch) => {
    try {
        let objResp = await disclaimer();
        let data = await objResp?.data;
        dispatch(disclaimerSuccess(data));
        return Promise.resolve(data);
    } catch (error) {
        console.log(error);
        dispatch(disclaimerFailure([]));
    }

};
export const disclaimerSuccess = (objResp) => {
    return { type: APP_INFO.GET_DISCLAIMER_SUCCESS, payload: objResp };
};

export const disclaimerFailure = (payload) => {
    return { type: APP_INFO.GET_DISCLAIMER_FAILURE, payload };
};

export const getStatesAndCities = () => async (dispatch) => {
    try {
        const objResp = await statesCities();
        const data = objResp?.data?.states.map((item) => ({ id: item.id, name: item.name, cities: item.cities?.map((city) => ({ name: city.name, id: city.id })) }));
        dispatch(statesAndCitiesSuccess(data));
    } catch (error) {
        console.log(error);
        dispatch(statesAndCitiesFailre([]));

    }
};

export const statesAndCitiesSuccess = (payload) => {
    return { type: APP_INFO.GET_STATES_AND_CITIES_SUCCESS, payload };
};
export const statesAndCitiesFailre = (payload) => {
    return { type: APP_INFO.GET_STATES_AND_CITIES_FAILURE, payload };
};


export const getExchangeTimings = () => async (dispatch) => {
    try {
        const objResp = await exchangeTimings();
        dispatch(exchangeTimingsSuccess(objResp.data));
    } catch (error) {
        console.log(error);
        dispatch(exchangeTimingsFailure([]));
    }

};
export const exchangeTimingsSuccess = (objResp) => {
    return { type: APP_INFO.GET_EXCHANGETIMINGS_SUCCESS, payload: objResp };
};

export const exchangeTimingsFailure = (payload) => {
    return { type: APP_INFO.GET_EXCHANGETIMINGS_FAILURE, payload };
};

export const getbrokerInformation = () => async (dispatch) => {
    try {
        const objResp = await brokerInformation();
        dispatch(brokerInformationSuccess(objResp.data));

    } catch (error) {
        console.log(error);
        dispatch(brokerInformationFailure([]));
    }

};
export const brokerInformationSuccess = (objResp) => {
    return { type: APP_INFO.GET_BROKERINFORMATION_SUCCESS, payload: objResp };
};

export const brokerInformationFailure = (payload) => {
    return { type: APP_INFO.GET_BROKERINFORMATION_FAILURE, payload };
};

export const setChartAttributes = (payload) => {
    return { type: APP_INFO.SET_CHART_ATTRIBUTES, payload };
};
//Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - Start
export const getDynamicMenus = () => async (dispatch, getState) => {
    const objAppInfo = getState()?.appInfo.appInfo;
    const nCMOTMode = getAppInfoData(APP_INFO_PARAMS.APP_CMOT_MODE, objAppInfo);
    try {
        const resp = await _getDynamicMenus(nCMOTMode);
        if (resp?.status) {
            dispatch(updateDynamicMenus(resp?.data));
        }
    } catch (error) {
        console.log(error);
        dispatch(updateDynamicMenus([]));
    }
};
export const updateDynamicMenus = (objResp) => {
    return { type: APP_INFO.UPDATE_DYNAMIC_MENUS, payload: objResp };
};
//Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - End

//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
export const updateInAppIFrame = (payload) => {
    return { type: APP_INFO.UPDATE_INAPP_IFRAME, payload };
};

// { /* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - Start */ }
export const openHamburgerMenu = () => {
    return { type: APP_INFO.SET_DASH_MENU, payload: true };
};

export const closeHamburgerMenu = () => {
    return { type: APP_INFO.SET_DASH_MENU, payload: false };
};
// { /* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - End */ }
//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End